import script from "./depositPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./depositPopup.vue?vue&type=script&setup=true&lang=ts"

import "./depositPopup.vue?vue&type=style&index=0&id=4459e326&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4459e326"]])

export default __exports__